/**
 * @module TelephonyConfig
 */


export enum TelephonyRoutingDeviceTypes {
    /**
     * Unknown, the device has not been still defined
     */
    UNKNOWN= "unknown",

    /**
     * VOIP mode
     */
    COMPUTER = "computer",

    /**
     * Office phone
     */
    OFFICE_PHONE = "officePhone",

    /**
     * Work mobile
     */
    MOBILE_PRO = "mobilePro",

    /**
     * Personal mobile
     */
    MOBILE_PERSO = "mobilePerso",

    /**
     * Personal phone
     */
    PHONE_PERSO = "phonePerso",

    /**
     * Other phone
     */
    OTHER_PHONE = "otherPhone"// other phone
}

/*export enum UserTelephonyStates {
    NO_TELEPHONY = "noTelephony",
    TELEPHONY_STOPPED = "telephonyStopped",
    TELEPHONY_STARTED = "telephonyStarted"
}*/

export enum TelephonyRoutingErrors {
    /**
     * Telephony Routing is not correctly configured => contact Administrator
     */
    WRONG_CONFIG = "wrongConfiguration",

    /**
     * You have no phone number associated to your business line
     */
    NO_SECONDARY_PHONE_ASSOCIATED = "noSecondaryPhoneAssociated",

    /**
     * Telephony Routing not configured
     */
    MOBILE_PHONE_IS_IN_LOGOUT = "mobilePhoneIsInLogout",

    /**
     * The mediapillar is down
     */
    MEDIAPILLAR_UNAVAILABLE = "mediapillarUnavailable",

    /**
     * Office phone is temporarily unavailable
     */
    OFFICE_PHONE_UNAVAILABLE = "officePhoneUnavailable"
}

export interface TelephonyRoutingDevice {
    /**
     * Type of the device that the user has specified in this user profile
     * @readonly
     */
    deviceType: TelephonyRoutingDeviceTypes;

    /**
     * Device activated
     * if deviceActivate is true, the device can been selected and used
     * if deviceActivate is false the device is present but not usable
     * @readonly
     */
    deviceAvailable: boolean;
}

export interface TelephonyRoutingMode {

    /**
     * State of Telephony
     * @readonly
     */
    isTelephonyStarted: boolean;

    /**
     * Telephony Routing Mode can be changed
     * @readonly
     */
    isTelephonyRoutingModeCanBeChanged: boolean;

    /**
     * Routing error
     * @readonly
     */
    routingError?: TelephonyRoutingErrors;

    /**
     * Type of the device uses by the user
     * @readonly
     */
    currentDeviceType: TelephonyRoutingDeviceTypes;

    /**
     * Routing destination if device type selected is otherphone
     * @readonly
     */
    currentDestination?: string;

    /**
     * Only Office Phone is ringing
     * if office phone selected and user has a mobile pro or mobile perso in his profile
     * if isOnlyOfficePhoneRinging is true only office phone of the user rings
     * else office phone and his work mobile (or personal mobile) ring together
     * @readonly
     */
    isOnlyOfficePhoneRinging: boolean;
}
/**
* @internal
*/
export class TelephonyRoutingModeRB implements TelephonyRoutingMode {

    /**
     * State of Telephony
     * @readonly
     */
    isTelephonyStarted: boolean;

    /**
     * Telephony Routing Mode can be changed
     * @readonly
     */
    isTelephonyRoutingModeCanBeChanged: boolean;

    /**
     * Routing error
     * @readonly
     */
    routingError: TelephonyRoutingErrors;

    /**
     * Type of the device uses by the user
     * @readonly
     */
    currentDeviceType: TelephonyRoutingDeviceTypes;

    /**
     * Routing destination if device type selected is otherphone
     * @readonly
     */
    currentDestination?: string;

    /**
     * Only Office Phone is ringing
     * if office phone selected and user has a mobile pro or mobile perso in his profile
     * if isOnlyOfficePhoneRinging is true only office phon e of the user rings
     * else office phone and his work mobile (or personal mobile) rinf together
     * @readonly
     */
    isOnlyOfficePhoneRinging: boolean;

    constructor() {
        this.isTelephonyStarted = false;
        this.isTelephonyRoutingModeCanBeChanged = false;
        this.currentDeviceType = TelephonyRoutingDeviceTypes.UNKNOWN;
        this.isOnlyOfficePhoneRinging = false;
    }
}
